import * as angular from 'angular';
import { EnumService } from './enum.service';
import { TransferFileService } from './transferFile.service';

export class DppExportCsvService {
    public static $inject = ['transferFileService', 'enumService'];

    constructor(
        private transferFileService: TransferFileService,
        private enumService: EnumService
    ) {
    }

    public exportToCsv(rows: string[][], fileName: string) {
        let csvContent = '';

        rows.forEach((rowArray) => {
            const row = rowArray.join(';');
            csvContent += row + '\r\n';
        });
        this.transferFileService.transferFile(csvContent, fileName, this.enumService.ExportFileType.CSV);
    }
}

angular.module('app.common').service('dppExportCsvService', DppExportCsvService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/dpp-export-csv.service.ts